import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.delete', {
        url: '/delete',
        params: {accounts: []},
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsDelete'
        },
        resolve: {
            selectedAccounts,
        },
    });
}

/** @ngInject */
function selectedAccounts($stateParams) {
    return $stateParams.accounts;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/delete/delete-accounts.state.js